module.exports = __webpack_public_path__ + "static/media/44.e94f770d.mp3";